var map = {
	"./1.jpg": 533,
	"./2.jpg": 6527,
	"./3.jpg": 7048,
	"./4.jpg": 9026,
	"./5.jpg": 1318,
	"./6.jpg": 8691,
	"./7.jpg": 6707,
	"./8.jpg": 909
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1809;